import { useEffect, useRef } from "react";

const DEFAULT_VIEWPORT = "width=device-width, initial-scale=1";

type Viewport = { width?: number | string; initialScale?: number };

// Note... if there are multiple components that use this hook and
// the effects are applied in the same render, the parent effect will
// win. If you want to change this behavior, then the Context API will
// have to be used. A workaround is to conditionally render child components
// so they are in a separate render.

// Initial scale is only applied if a width is applied
const useViewport = ({ width, initialScale }: Viewport, deps: any[] = []) => {
  const viewport = document.querySelector('meta[name="viewport"]');
  const initialViewport = useRef<string | null>(
    viewport?.getAttribute("content") ?? null
  );

  useEffect(() => {
    const viewport = document.querySelector('meta[name="viewport"]');

    if (!viewport) {
      return;
    }

    const viewportContent = viewport.getAttribute("content");

    if (initialViewport.current == null) {
      initialViewport.current = viewportContent;
    }

    if (width === "initial") {
      viewport.setAttribute("content", initialViewport.current!);
    } else if (width) {
      viewport.setAttribute(
        "content",
        `width=${width}, initial-scale=${initialScale ?? 1}`
      );
    } else {
      viewport.setAttribute("content", DEFAULT_VIEWPORT);
    }

    return () => {
      viewport.setAttribute("content", initialViewport.current!);
    };
  }, [width, ...deps]);
};

export default useViewport;
